import { render, staticRenderFns } from "./simpleAddCompany.vue?vue&type=template&id=64d417f5&scoped=true&"
import script from "./simpleAddCompany.vue?vue&type=script&lang=js&"
export * from "./simpleAddCompany.vue?vue&type=script&lang=js&"
import style0 from "./simpleAddCompany.vue?vue&type=style&index=0&id=64d417f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d417f5",
  null
  
)

export default component.exports